import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { economyStore, economySyncStore } from '@puzzlemania/economy';
import { AppTopBar, useFullscreenToggle } from '@puzzlemania/ui';
/**
 * Module 32 (WP-UI.2) — the Lobby now renders the locked shared `<AppTopBar>` with the
 * Logo as its `leftSlot`, exactly like the games render it with a Home button. This owns the
 * economy-store subscription (keeping `packages/ui` free of any `@puzzlemania/economy` dep)
 * and passes the balances in; the bar owns the layout (centered currency, side anchors,
 * safe-area). Replaces the bespoke `global-header__actions` currency/settings wiring and the
 * deleted lobby-only `CurrencyBar`.
 */
export function GlobalHeader({ coinIconUrl, onShopClick, onSettingsClick, fullscreen, } = {}) {
    const { t } = useTranslation();
    const fullscreenToggle = useFullscreenToggle(fullscreen);
    const coins = economyStore((s) => s.coins);
    const gems = economyStore((s) => s.gems);
    const isSyncing = economySyncStore((s) => s.pendingCount > 0);
    return (_jsx(AppTopBar, { className: "global-header", leftSlot: _jsx("img", { src: "/puzzlemania-logo.png", alt: t('app.name'), className: "global-header__logo" }), coins: coins, gems: gems, isSyncing: isSyncing, ...(coinIconUrl ? { coinIconUrl } : {}), ...(onShopClick ? { onShopClick } : {}), ...(onSettingsClick ? { onSettingsClick } : {}), ...(fullscreenToggle ? { fullscreen: fullscreenToggle } : {}) }));
}
